import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SecurityPoliciesApiService {

  constructor(private http: HttpClient) {}

  private readonly securityPolicyUrl: string = 'security/policy';

  public getSecurityPolicies(): Observable<any> {
    return this.http.get(this.securityPolicyUrl);
  }

  public getSecurityRoles(): Observable<any> {
    return this.http.get(`${this.securityPolicyUrl}/roles`);
  }

  public addSecurityPolicy(securityPolicy): Observable<any> {
    return this.http.post(this.securityPolicyUrl, securityPolicy);
  }

  public updateSecurityPolicy(securityPolicy): Observable<any> {
    return this.http.put(`${this.securityPolicyUrl}/${securityPolicy.id}`, securityPolicy);
  }

  public deleteSecurityPolicy(securityPolicyId): Observable<any> {
    return this.http.delete(`${this.securityPolicyUrl}/${securityPolicyId}`);
  }
}
